'use strict';
define(['angular'], function (angular) {
    function Controller($scope, $translate, keywordLimit, listsProperties, SearchConsoleService, $filter, $window, $mdToast, $state) {
        var mutex = 0;
        var vm = $scope;
        vm.loading = false;

        vm.listsProperties = listsProperties && listsProperties.length > 0 ? listsProperties : [];
        vm.website = vm.listsProperties.length ? vm.listsProperties[0].siteUrl : '';

        try {
            vm.pendingProject = JSON.parse($window.localStorage.getItem('searchConsolePendingProject') || 'null');
            vm.projectCallback = JSON.parse($window.localStorage.getItem('searchConsoleProjectCallback') || 'null');
        } catch (e) {
            vm.pendingProject = null;
            vm.projectCallback = null;
        }
        if (!vm.pendingProject && vm.projectCallback && vm.projectCallback.projectId) {
            vm.pendingProject = {id: vm.projectCallback.projectId, url: ''};
        }

        vm.connectProperty = function () {
            if (!vm.pendingProject || !vm.website) return;
            if (vm.projectCallback && vm.projectCallback.projectId) {
                SearchConsoleService.connectProjectProperty(vm.projectCallback.projectId, vm.website)
                    .then(completeConnection)
                    .catch(function () {
                        showToast('error.permissions.website');
                    });
                return;
            }
            SearchConsoleService.saveProjectProperty(vm.pendingProject.id, vm.pendingProject.workspaceId, vm.website);
            completeConnection();
        };

        function completeConnection() {
            var projectId = vm.pendingProject && vm.pendingProject.id
                || vm.projectCallback && vm.projectCallback.projectId;
            var returnState = vm.pendingProject && vm.pendingProject.returnState;
            var returnParams = vm.pendingProject && vm.pendingProject.returnParams;
            $window.localStorage.removeItem('searchConsolePendingProject');
            $window.localStorage.removeItem('searchConsoleProjectCallback');
            if ($window.opener) $window.close();
            else if (returnState) $state.go(returnState, returnParams || {projectId: projectId});
            else if (projectId) $state.go('app.project.detail.searchConsole', {projectId: projectId, view: 'query'});
        }

        if (vm.projectCallback && vm.projectCallback.propertyUrl) {
            completeConnection();
        }

        if (vm.pendingProject) {
            var matchingProperty = SearchConsoleService.findMatchingProperty(vm.pendingProject.url, vm.listsProperties);
            vm.website = matchingProperty || vm.website;
            if (matchingProperty && !vm.projectCallback) {
                vm.connectProperty();
            }
        }

        vm.projectName = localStorage.getItem('projectName');
        vm.searchConsoleToken = localStorage.getItem('googleSearchConsoleToken');

        vm.rowLimit = keywordLimit;

        vm.range = {
            startDate: new Date(),
            endDate: new Date()
        };

        vm.range.startDate.setDate(1);
        vm.range.startDate.setMonth(vm.range.startDate.getMonth() - 1);

        vm.applyRangeOfDate = function (range) {
            vm.range = {
                startDate: new Date(range.startDate),
                endDate: new Date(range.endDate)
            };
        };

        vm.closeWindow = function () {
            $window.close();
        };

        vm.formatUrl = function (url) {
            return url.replace('sc-domain:', '');
        };

        vm.getKeywords = function () {
            if (mutex === 1) {
                return;
            }

            mutex = 1;
            vm.loading = true;

            if (!vm.searchConsoleToken) {
                mutex = 0;
                vm.loading = false;
                return;
            }

            SearchConsoleService.getQueries(vm.searchConsoleToken, {
                website: vm.website,
                rowLimit: vm.rowLimit,
                range: {
                    startDate: $filter('date')(vm.range.startDate, 'yyyy-MM-dd'),
                    endDate: $filter('date')(vm.range.endDate, 'yyyy-MM-dd'),
                }
            })
                .then(function (res) {
                    mutex = 0;
                    vm.loading = false;

                    if (res.data.message === 'Not have permission') {
                        showToast();
                        setTimeout(function () {
                            $window.close();
                        }, 1500);
                    } else {
                        $window.close();
                    }
                })
                .catch(function (err) {
                    mutex = 0;
                    vm.loading = false;
                    console.log(err);

                    showToast('error.notfound.keyword');
                    setTimeout(function () {
                        $window.close();
                    }, 1500);
                });
        };

        function showToast(errorMessage) {
            var defaultError = 'error.permissions.website';
            $mdToast.show({
                template:
                    '<md-toast layout="row" flex class="md-toast">' +
                    '   <div><i class="icon-x st-err m-r-sm"></i></div>' +
                    '   <div>' + $translate.instant(errorMessage || defaultError) + ' ' + vm.website.siteUrl + '</div>' +
                    '</md-toast>',
                hideDelay: 5000,
                position: 'top right'
            });
        }
    }

    Controller.$inject = ['$scope', '$translate', 'keywordLimit', 'listsProperties', 'SearchConsoleService', '$filter', '$window', '$mdToast', '$state'];
    return Controller;
});
